import { motion } from 'framer-motion';
import { Card, CardContent } from '../../ui/Card';
import { SparklesIcon } from '@heroicons/react/24/outline';

export function AIAnalysisLoading() {
  return (
    <div className="min-h-screen bg-surface-50 dark:bg-surface-900 px-4 py-8 flex items-center justify-center">
      <div className="max-w-2xl w-full space-y-6">
        {/* Animated Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 200 }}
          className="flex justify-center"
        >
          <motion.div
            animate={{
              rotate: 360,
              scale: [1, 1.1, 1],
            }}
            transition={{
              rotate: { duration: 3, repeat: Infinity, ease: 'linear' },
              scale: { duration: 2, repeat: Infinity, ease: 'easeInOut' },
            }}
            className="w-20 h-20 rounded-full bg-gradient-to-br from-accent-400 to-primary-500 flex items-center justify-center"
          >
            <SparklesIcon className="w-10 h-10 text-white" />
          </motion.div>
        </motion.div>

        {/* Header */}
        <div className="text-center space-y-2">
          <h2 className="text-3xl font-bold text-surface-900 dark:text-surface-100">
            Analyzing Your Day
          </h2>
          <p className="text-surface-600 dark:text-surface-400">
            AI is reviewing your responses and generating personalized insights
          </p>
        </div>

        {/* Progress Steps */}
        <Card variant="default">
          <CardContent>
            <div className="space-y-4">
              {[
                { label: 'Reviewing your responses', delay: 0 },
                { label: 'Identifying patterns', delay: 0.5 },
                { label: 'Consulting the Big Book', delay: 1 },
                { label: 'Generating insights', delay: 1.5 },
              ].map((step) => (
                <motion.div
                  key={step.label}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: step.delay }}
                  className="flex items-center gap-3"
                >
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: step.delay + 0.2 }}
                    className="w-2 h-2 rounded-full bg-accent-500"
                  />
                  <span className="text-surface-700 dark:text-surface-300">
                    {step.label}
                  </span>
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: '100%' }}
                    transition={{ delay: step.delay, duration: 1 }}
                    className="flex-1 h-1 bg-surface-200 dark:bg-surface-700 rounded-full overflow-hidden"
                  >
                    <motion.div
                      initial={{ width: 0 }}
                      animate={{ width: '100%' }}
                      transition={{ delay: step.delay + 0.2, duration: 0.8 }}
                      className="h-full bg-accent-500"
                    />
                  </motion.div>
                </motion.div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Encouragement */}
        <p className="text-center text-sm text-surface-500 dark:text-surface-400">
          This usually takes 10-15 seconds...
        </p>
      </div>
    </div>
  );
}

export default AIAnalysisLoading;
